import { Controller } from '@hotwired/stimulus';

export default class ApplicationController extends Controller {}
